import {
  GridPreferencePanelsValue,
  useGridApiContext,
} from '@mui/x-data-grid-premium';
import { ReactNode, useCallback, useState } from 'react';
import Pill from '@ingka/pill';
import { QuickSearchInput } from './QuickSearchInput';
import { Box, Checkbox, Divider, ListItemText, MenuItem } from '@mui/material';

import chevronDown from '@ingka/ssr-icon/paths/chevron-down';
import filterIcon from '@ingka/ssr-icon/paths/filters';
import ArrowDown from '@ingka/ssr-icon/paths/arrow-up-to-base';
import reloadIcon from '@ingka/ssr-icon/paths/circlepath-two-triangles';
import saveIcon from '@ingka/ssr-icon/paths/folder';
import Tooltip from '@ingka/tooltip';
import useTranslation from '../../../hooks/useTranslation';
import Menu from '@mui/material/Menu';
import { ISEPFilter } from './IsepFilter';
import { ConfidentialityFilter } from './ConfidentialityFilter';
import { FYBudgetFilter } from './FYBudgetFilter';

const returnAppliedFilters = (apiRef: any) => {
  return apiRef.current.state.filter.filterModel.items.length;
};

export const CustomToolbar = ({
  controls,
  handleStorage,
  handleReset,
  views,
  onViewClick,
}: {
  controls: ReactNode;
  handleStorage: () => void;
  handleReset: () => void;
  views?: { label: string; value: string }[];
  onViewClick: (view: string) => void;
}) => {
  const apiRef = useGridApiContext();
  const t = useTranslation();
  const [selectedView, setSelectedView] = useState<string>('default');

  const toggleFilter = useCallback(() => {
    apiRef.current.showFilterPanel();
  }, [apiRef]);

  const toggleColumnVisibility = useCallback(() => {
    apiRef.current.showPreferences(GridPreferencePanelsValue.columns);
  }, [apiRef]);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={2}>
        <Pill
          label="Columns"
          onClick={toggleColumnVisibility}
          size="small"
          trailingIcon={chevronDown}
        />
        <Pill
          label={`Filter ${returnAppliedFilters(apiRef) > 0 ? `(${returnAppliedFilters(apiRef)})` : ''}`}
          onClick={toggleFilter}
          size="small"
          trailingIcon={filterIcon}
        />
        {views && (
          <Pill
            label={`Views`}
            onClick={handleClick}
            size="small"
            trailingIcon={chevronDown}
          />
        )}
        <ISEPFilter />
        <ConfidentialityFilter />
        <FYBudgetFilter />
        <Pill
          label={`Export Excel`}
          onClick={() => apiRef.current.exportDataAsExcel()}
          size="small"
          trailingIcon={ArrowDown}
        />

        {handleReset && (
          <Tooltip
            position="bottom"
            tooltipText={t('ppm.actions.resetToDefaults')}
            describedById={'reset-tooltip'}
          >
            <Pill
              label={t('ppm.actions.resetToDefaults')}
              onClick={handleReset}
              size="small"
              trailingIcon={reloadIcon}
            />
          </Tooltip>
        )}
        {handleStorage && (
          <Tooltip
            position="bottom"
            tooltipText={'Save settings'}
            describedById={'save-tooltip'}
          >
            <Pill
              onClick={handleStorage}
              size="small"
              trailingIcon={saveIcon}
            />
          </Tooltip>
        )}

        {controls && (
          <>
            <Divider orientation="vertical" flexItem sx={{ my: 1.5 }} />
            {controls}
          </>
        )}

        <Box flexGrow={1} />

        <QuickSearchInput />
      </Box>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        {views?.map((view) => (
          <MenuItem
            key={view.value}
            onClick={() => {
              onViewClick(view.value);
              setSelectedView(view.value);
              handleClose();
            }}
          >
            <Checkbox checked={selectedView === view.value} />
            <ListItemText primary={view.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
